import React from 'react';
import styles from './TaskAssignment.module.scss';
import { eventMomentFactory } from '../../../../../../../data/misc/eventMomentFactory';
import UserAvatar from '../../../../../../elements/icons/UserAvatar/UserAvatar';
import ScheduleListItem from '../../../../../../elements/ScheduleListItem';
import UserName from '../../../../../../elements/UserName/UserName';
import TaskIcon from '../../../../../../../resources/icons/hand-regular.svg';

function TaskAssignment(props) {
    const { className, event, assignment } = props,
        { participant, is_self: isSelf } = assignment,
        start = eventMomentFactory(event, assignment.start_local),
        end = eventMomentFactory(event, assignment.end_local),
        icon = isSelf ? <TaskIcon className={styles.taskIcon} /> : <UserAvatar user={participant} size={48} />,
        href =['.', 'participants', participant.user_id ?? '-', participant.participant_id ?? '-'].join('/')

    return (
        <ScheduleListItem className={[className, isSelf ? styles.self : ''].join(' ')} event={event} icon={icon} start={start} end={end} href={href}>
            <div className="text name">
                <UserName user={participant} />
            </div>
        </ScheduleListItem>
    );
}

export default TaskAssignment;
